import { render, staticRenderFns } from "./orgmgt.vue?vue&type=template&id=8af24c7c&scoped=true"
import script from "./orgmgt.vue?vue&type=script&lang=js"
export * from "./orgmgt.vue?vue&type=script&lang=js"
import style0 from "./orgmgt.vue?vue&type=style&index=0&id=8af24c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af24c7c",
  null
  
)

export default component.exports